import { RadioGroup, RadioButton, Radio } from './web';
RadioGroup.Button = RadioButton;
RadioGroup.Radio = Radio;
export default RadioGroup;